import useBiometricDevices from "../hooks/use-biometric-devices";
import { useState } from "react";
import { Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import * as BiometricDeviceSlice from "../features/biometric-device/biometric-device.slice";
import Loader from "../components/loader";
import { BiometricDeviceRequest } from "../service/model/biometric.model";
import BiometricDeviceForm from "../features/biometric-device/components/biometric-device-form";
import BiometricDeviceTable from "../features/biometric-device/components/biometric-device-table";
import CreateButton from "../components/create-button";

const BiometricDevices = () => {
    const dispatch = useAppDispatch();
    const [showBiometricDeviceForm, setShowBiometricDeviceForm] = useState(false);
    const isLoading = useAppSelector(BiometricDeviceSlice.selectIsLoading);

    const [BiometricDevices] = useBiometricDevices();

    const handleSubmit = (data: BiometricDeviceRequest) => {
        dispatch(BiometricDeviceSlice.createBiometricDevice(data)).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowBiometricDeviceForm(false);
            }
        }).catch(err => {
            console.error(err);
        });
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {BiometricDevices &&
                <>
                    <Box sx={{ mb: "12px" }}>
                        <CreateButton variant="contained" onClick={() => setShowBiometricDeviceForm(true)} style={{ marginBottom: "12px" }}>Add Device</CreateButton>
                    </Box>
                    <BiometricDeviceTable devices={BiometricDevices} />
                    {showBiometricDeviceForm &&
                        <BiometricDeviceForm device={undefined} editable={true} onClose={() => setShowBiometricDeviceForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    )
}

export default BiometricDevices;